import {agentRequest} from '../services/request';
import {agentEndpoints} from '../../api';
import {apiHelpers} from '../../utils/helpers';
import {agentTypeConstants} from '../../constants';
import {agentConstants} from '../constants';

const {getUrl} = apiHelpers;

const errorHandlerProps = {disableAlert: true};

const createCompanyPolicy = ({data, successCallback, errorCallback}) => {
  return (dispatch) => {
    agentRequest.post({
      dispatch,
      url: agentEndpoints.POST_CREATE_COMPANY_POLICY,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getCompanyPolicies = ({query = null, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    agentRequest.get({
      dispatch,
      url: agentEndpoints.GET_COMPANY_POLICIES,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const updateCompanyPolicy = ({id, data, successCallback, errorCallback}) => {
  return (dispatch) => {
    agentRequest.patch({
      dispatch,
      url: getUrl(agentEndpoints.PATCH_UPDATE_COMPANY_POLICY, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getFlowGreetingMessage = ({flow, successCallback, errorCallback}) => {
  return (dispatch) => {
    agentRequest.get({
      dispatch,
      url: getUrl(agentEndpoints.GET_FLOW_GREETING_MESSAGE, {flow}),
      successCallback: (response) => {
        const message = response?.message || '';
        const quickActions = response?.quick_actions || [];
        dispatch({
          type: agentConstants.SET_FLOW_GREETING_MESSAGE,
          data: {flow, message, quickActions}
        });
        successCallback?.(response);
      },
      errorCallback,
      errorHandlerProps
    });
  }
}

/** A chat session's stored messages: `successCallback` receives the page's `results`. */
const getSessionMessages = ({flow, sessionId, successCallback, errorCallback}) => {
  return (dispatch) => {
    agentRequest.get({
      dispatch,
      url: getUrl(agentEndpoints.GET_SESSION_MESSAGES, {flow, session_id: sessionId}),
      successCallback: (response) => successCallback?.(response?.results || []),
      errorCallback,
      errorHandlerProps
    });
  }
}

const openAgentChat = ({variant = agentTypeConstants.ADD_NEW_EXPENSE, query = {}} = {}) => {
  return (dispatch) => {
    dispatch({
      type: agentConstants.OPEN_AGENT_CHAT,
      data: { variant, query },
    });
  }
}

const updateAgentChatProps = ({variant = agentTypeConstants.ADD_NEW_EXPENSE, query = {}}) => {
  return (dispatch) => {
    dispatch({
      type: agentConstants.UPDATE_AGENT_CHAT_PROPS,
      data: { variant, query, listenWebsocketConnection: true },
    });
  }
}

const closeAgentChat = () => {
  return (dispatch) => {
    dispatch({
      type: agentConstants.CLOSE_AGENT_CHAT,
    });
  }
}

export const agentActions = {
  createCompanyPolicy,
  getCompanyPolicies,
  updateCompanyPolicy,
  openAgentChat,
  closeAgentChat,
  updateAgentChatProps,
  getFlowGreetingMessage,
  getSessionMessages,
};
